import { render } from "./NotFoundPage.vue?vue&type=template&id=3c2bbe76&scoped=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&lang=js"

import "./NotFoundPage.vue?vue&type=style&index=0&id=3c2bbe76&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2bbe76"]])

export default __exports__